<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row mb-4">
    <div class="col-12">
      <div class="mb-2">
        <input
          class="form-control"
          formControlName="name"
          inputValidator
          label="TARIFFS.NAME"
          maxlength="200">
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProvidersService.getAll.bind(utilityProvidersService)"
          formControlName="utilityProviderId"
          inputValidator
          label="MENU.UTILITY_PROVIDERS"
        />
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProviderTypesService.getAll.bind(utilityProviderTypesService)"
          [parentControl]="form.get('utilityProviderId')"
          formControlName="utilityProviderTypeId"
          inputValidator
          label="METER_TYPE.UTILITY_TYPE"
        >
        </autocomplete>
      </div>
    </div>
    <div class="col-12">
      <p-inputNumber
        [useGrouping]="false"
        mode="decimal"
        class="w-100"
        styleClass="w-100"
        inputStyleClass="form-control"
        formControlName="price"
        inputValidator
        [minFractionDigits]="0"
        [maxFractionDigits]="5"
        label="TARIFFS.PRICE"
      />
    </div>
    <div class="col-12">
      <div class="form-check form-switch mt-2">
        <input class="form-check-input" formControlName="status" role="switch" type="checkbox">
        <label class="form-check-label">{{ 'TARIFFS.STATUS' | translate }}</label>
      </div>
    </div>
  </div>
  <div class="text-end d-flex gap-2 justify-content-end">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
    <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
